export enum PROrbitPlanCode {
	STDIS = 1,
	STG = 2,
	STL = 3,
	STMAX = 4,
	STRE = 5,
	STRS = 6,
}
